unable to read source [project]/node_modules/posthog-js/react/src/utils/object-utils.ts